/**
 * Bug report submission endpoints.
 */
import type {
  BugReportSubmitResponse,
  SubmitBugReportPayload,
} from '@/types/api';
import { apiClient } from './client';

export const bugReportsApi = {
  submit: (payload: SubmitBugReportPayload) => {
    const fd = new FormData();
    fd.append('category', payload.category);
    fd.append('title', payload.title);
    fd.append('description', payload.description);
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      fd.append('user_agent', navigator.userAgent);
    }
    const appVersion = import.meta.env.VITE_APP_VERSION as string | undefined;
    if (appVersion) {
      fd.append('app_version', appVersion);
    }
    for (const file of payload.screenshots ?? []) {
      fd.append('screenshots', file);
    }
    return apiClient.postMultipart<BugReportSubmitResponse>('/bug-reports', fd);
  },
};

// ============================================================================
// NOTIFICATION PREFERENCES
// ============================================================================
